import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import type { ThemeContextValue } from '@/hooks/shared/useThemeColors';

interface VerificationScreenProps {
  route: {
    params: {
      email: string;
      isSignup: boolean;
    };
  };
}

export const VerificationScreen: React.FC<VerificationScreenProps> = ({ route }) => {
  const { email, isSignup } = route.params;
  const styles = useThemedStyles(makeStyles);

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView contentContainerStyle={styles.content}>
        <Text style={styles.title}>Verification</Text>
        <Text style={styles.subtitle}>
          We've sent a verification code to {email}
        </Text>
        <Text style={styles.info}>
          {isSignup ? 'Complete your signup' : 'Verify your email'} by entering the code below.
        </Text>
        {/* TODO: Implement verification form */}
        <Text style={styles.placeholder}>
          [Verification form will be implemented here]
        </Text>
      </ScrollView>
    </SafeAreaView>
  );
};

const makeStyles = ({ colors }: ThemeContextValue) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.bg.base,
  },
  content: {
    flexGrow: 1,
    padding: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
    color: colors.text.primary,
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 8,
    textAlign: 'center',
    color: colors.text.primary,
  },
  info: {
    fontSize: 14,
    color: colors.text.secondary,
    marginBottom: 32,
    textAlign: 'center',
  },
  placeholder: {
    fontSize: 14,
    color: colors.text.muted,
    fontStyle: 'italic',
    textAlign: 'center',
  },
});
